function getReadManyInputQueryString(schema, variables = {}) {
  const { paginationStrategy, sortStrategy, searchStrategy } = schema;
  const inputPairs = [];
  if (paginationStrategy) {
    inputPairs.push({ key: 'skip', value: variables.skip });
    inputPairs.push({ key: 'limit', value: variables.limit });
  }

  if (sortStrategy) {
    // note: the replace is used to remove quotes from properties
    const sortValue = [].concat(variables.sort);
    const shouldAddDefaultSort =
      sortStrategy.type === 'SINGLE' && sortValue.length === 0 && sortStrategy.defaultSortField;
    if (shouldAddDefaultSort) {
      sortValue.push({
        field: sortStrategy.defaultSortField,
        order: 'ASC',
      });
    }
    inputPairs.push({
      key: 'sort',
      value: JSON.stringify(sortValue).replace(/"([^(")"]+)":/g, '$1:'),
    });
  }

  if (searchStrategy) {
    inputPairs.push({
      key: 'search',
      value: `"${variables.search}"`,
    });
  }

  if (variables.filter && Object.entries(variables.filter).length > 0) {
    const filterValue = [];
    Object.entries(variables.filter).forEach((element) => {
      const values = element.slice(1);
      if (values.length > 0 && values[0] !== '') {
        const valueTypes = values.map(val => typeof val);
        filterValue.push({
          field: element[0],
          type: 'string',
          values,
          valueTypes,
        });
      }
    });
    inputPairs.push({
      key: 'filter',
      value: JSON.stringify(filterValue).replace(/"([^(")"]+)":/g, '$1:'),
    });
  }

  if (Object.keys(inputPairs).length === 0) {
    return '';
  }

  const string = inputPairs.map(({ key, value }) => [key, value].join(': ')).join(', ');

  return `(${string})`;
}

export default getReadManyInputQueryString;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/ReadManyLib/getReadManyInputQueryString.js